import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGoalClick = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.click-st0{fill:#6D6761;}\n	.click-st1{fill:#FFFFFF;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "click-st0",
			d: "M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0s12,5.4,12,12S18.6,24,12,24z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M7.9,10.3L5.1,11"
		}), /* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M5.1,11.4c-0.2,0-0.4-0.2-0.5-0.4c-0.1-0.3,0.1-0.5,0.4-0.6l2.9-0.6c0.3-0.1,0.5,0.1,0.6,0.4 c0.1,0.3-0.1,0.5-0.4,0.6l-2.9,0.6C5.1,11.4,5.1,11.4,5.1,11.4z"
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M8.2,11.7l-1.8,2.1"
		}), /* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M6.5,14.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5-0.1-0.7l1.8-2.1c0.2-0.2,0.5-0.2,0.7-0.1 c0.2,0.2,0.2,0.5,0.1,0.7l-1.8,2.1C6.7,14.2,6.6,14.2,6.5,14.2z"
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M7.6,9L5.2,8"
		}), /* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M7.6,9.5c-0.1,0-0.1,0-0.2,0L5,8.5C4.8,8.4,4.7,8.1,4.8,7.8c0.1-0.3,0.4-0.4,0.6-0.3l2.4,1 c0.2,0.1,0.4,0.4,0.3,0.6C8,9.4,7.8,9.5,7.6,9.5z"
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M11.3,7.5l0.9-2.8"
		}), /* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M11.3,8c0,0-0.1,0-0.1,0c-0.3-0.1-0.4-0.4-0.3-0.6l0.9-2.8c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6 l-0.9,2.8C11.7,7.9,11.5,8,11.3,8z"
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M9.6,7.2L9.4,4.5"
		}), /* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M9.6,7.7c-0.2,0-0.5-0.2-0.5-0.4L8.9,4.6C8.8,4.3,9,4.1,9.3,4c0.3,0,0.5,0.2,0.5,0.4l0.2,2.7 C10.1,7.4,9.9,7.7,9.6,7.7C9.6,7.7,9.6,7.7,9.6,7.7z"
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M12.6,8l2.1-1.9"
		}), /* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M12.6,8.4c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.5,0-0.7l2.1-1.9c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l-2.1,1.9C12.8,8.4,12.7,8.4,12.6,8.4z"
		})] }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "click-st1",
			d: "M12,18.7l-2.5-8.5c-0.2-0.8,0.6-1.5,1.4-1.1l7.3,3.6c0.7,0.4,0.7,1.4,0,1.8l-1.9,0.9l2.1,2.6 c0.3,0.4,0.3,0.9,0,1.3l-0.1,0.1c-0.4,0.5-1.1,0.4-1.5,0l-1.9-2.3l-1,2C13.4,19.7,12.3,19.6,12,18.7z"
		}) })
	]
});
export default SvgIconGoalClick;
